import { extendTheme } from "@mui/joy/styles";
import { createTheme } from "@mui/material/styles";

export const materialTheme = createTheme({
  palette: {
    background: {
      default: "#d9fbe7"
    },
    text: {
      primary: "#14532D"
    },
    common: {
      black: "#000",
      white: "#fff",
    },
    primary: {
      contrastText: "#ffffff",
      50: '#E8F5E9',
      100: '#C8E6C9',
      200: '#A5D6A7',
      300: '#81C784',
      400: '#66BB6A',
      500: '#4CAF50',
      600: '#43A047',
      700: '#388E3C',
      800: '#2E7D32', // Earthy green
      900: '#1B5E20',
      main: '#2E7D32', // Earthy green
    },
    secondary: {
      50: '#E0F2F1',
      100: '#B2DFDB',
      200: '#80CBC4',
      300: '#4DB6AC',
      400: '#26A69A',
      500: '#009688',
      600: '#00897B',
      700: '#00796B',
      800: '#00695C',
      900: '#004D40',
      main: '#00796B', // Teal
    },
  },
});

export const joyTheme = extendTheme({
  components: {
    JoyCard: {
      styleOverrides: {
        root: {
          // eslint-disable-next-line max-len
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.1) 0px 2px 4px -2px",
        },
      },
    },
  },
  colorSchemes: {
    light: {
      palette: {
        mode: "light",
        background: {
          body: "#d9fbe7",
        },
        text: {
          primary: "#14532D",
        },
        primary: {
          50: '#E8F5E9',
          100: '#C8E6C9',
          200: '#A5D6A7',
          300: '#81C784',
          400: '#66BB6A',
          500: '#4CAF50',
          600: '#43A047',
          700: '#388E3C',
          800: '#2E7D32', // Earthy green
          900: '#1B5E20',
        },
        success: {
          50: '#E0F2F1',
          100: '#B2DFDB',
          200: '#80CBC4',
          300: '#4DB6AC',
          400: '#26A69A',
          500: '#009688',
          600: '#00897B',
          700: '#00796B', // Teal
          800: '#00695C',
          900: '#004D40',
        },
      },
    },
  },
});
